import type { CalendarCategory, CalendarSlot } from "@/lib/preview-calendar";

/** Aplica un enlace MCP canjeado al calendario en vivo; null si la salida ya no existe o no alcanza. */
export function applyBookingLink(
  cal: { slots: CalendarSlot[]; categories: CalendarCategory[] },
  link: { date: string; startTimeId: number | null; quantities: Record<string, number> },
): { date: string; slot: CalendarSlot; qty: Record<string, number> } | null {
  const daySlots = cal.slots.filter((s) => s.date === link.date && s.available);
  const slot = (link.startTimeId != null ? daySlots.find((s) => s.startTimeId === link.startTimeId) : null) ?? daySlots[0];
  if (!slot) return null;
  const qty: Record<string, number> = {};
  for (const c of cal.categories) {
    const n = Math.max(0, Math.trunc(Number(link.quantities[c.id] ?? 0)));
    qty[c.id] = n;
  }
  const pax = Object.values(qty).reduce((a, b) => a + b, 0);
  if (pax === 0) return null;
  if (slot.capacity != null && pax > slot.capacity) return null;
  return { date: slot.date, slot, qty };
}
